import * as React from "react";
import images from "../assets/images";

const Logo: React.FC = () => {
  return (
    <div className="">
      <img src={images.logo} alt="" />
    </div>
  );
};

export default Logo;
